import { ErrorMessagePayload } from "./types";

export const getAllActiveWindows = async (worker: ServiceWorkerGlobalScope) => {
  return await worker.clients.matchAll({
    type: "window",
    includeUncontrolled: true,
  });
};

export async function isUserActive(
  worker: ServiceWorkerGlobalScope
): Promise<boolean> {
  const clients = await getAllActiveWindows(worker);
  return clients.length > 0;
}export function isErrorMessage(payload: any): payload is ErrorMessagePayload {
    return (
        typeof payload === "object" && "type" in payload && payload.type === "ERROR" 
    );
}
export const sendToAllClients = (
    worker: ServiceWorkerGlobalScope,
    message: any
) => {
    worker.clients.matchAll({ includeUncontrolled: true }).then((clients) => {
        console.log(
            "Sending message to clients (" + clients.length + "):",
            message
        );
        clients.forEach((client) => {
            client.postMessage(message);
        });
    });
};

